module.exports = "<div class=\"screen {{theme}} company-logo\" *ngIf=\"!authService.logoutInProgress\"><span id=\"watermark\"><p>{{watermarkText}}</p></span><header><header-bar></header-bar></header><div class=\"app-content\"><app-menu></app-menu><main role=\"main\"><app-context-menu></app-context-menu><router-outlet><app-preview-service></app-preview-service></router-outlet></main></div></div><app-notification-service></app-notification-service><app-maintenance-message></app-maintenance-message>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.pug
// module id = ./src/app/app.component.pug
// module chunks = main